var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "flex-column form-fields-contact" },
    [
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "civility",
            label: _vm.$t.__("common.labels.civility")
          }
        },
        [
          _c(
            "el-select",
            {
              staticClass: "wp-10",
              attrs: {
                "data-bot": _vm.getDatabot("civility", _vm.currentStore)
              },
              model: {
                value: _vm.civility,
                callback: function($$v) {
                  _vm.civility = $$v
                },
                expression: "civility"
              }
            },
            _vm._l(_vm.civilities, function(option) {
              return _c("el-option", {
                key: option.value,
                attrs: { value: option, label: option.label }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { prop: "name", label: _vm.$t.__("common.labels.name") } },
        [
          _c("el-input", {
            ref: "name",
            attrs: {
              name: "lastname",
              autocomplete: "off",
              "data-bot": _vm.getDatabot("lastname", _vm.currentStore)
            },
            model: {
              value: _vm.name,
              callback: function($$v) {
                _vm.name = $$v
              },
              expression: "name"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "forename",
            label: _vm.$t.__("common.labels.first_name")
          }
        },
        [
          _c("el-input", {
            attrs: {
              name: "firstname",
              autocomplete: "off",
              "data-bot": _vm.getDatabot("firstname", _vm.currentStore)
            },
            model: {
              value: _vm.forename,
              callback: function($$v) {
                _vm.forename = $$v
              },
              expression: "forename"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "role",
            label: _vm.$t.__(
              "thirds.thirdscomponents.FormFieldsContact.position"
            )
          }
        },
        [
          _c("el-input", {
            attrs: {
              autocomplete: "off",
              "data-bot": _vm.getDatabot("role", _vm.currentStore)
            },
            model: {
              value: _vm.role,
              callback: function($$v) {
                _vm.role = $$v
              },
              expression: "role"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "birthdate",
            label: _vm.$t.__("common.labels.birthdate")
          }
        },
        [
          _c("el-date-picker", {
            attrs: {
              type: "date",
              format: _vm.datePickerFormat,
              "data-bot": _vm.getDatabot("birthdate", _vm.currentStore),
              placeholder: _vm.datePickerFormat.toUpperCase()
            },
            model: {
              value: _vm.birthdate,
              callback: function($$v) {
                _vm.birthdate = $$v
              },
              expression: "birthdate"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { prop: "email", label: _vm.$t.__("common.labels.email") } },
        [
          _c("el-input", {
            ref: "email",
            attrs: {
              type: "email",
              "data-bot": _vm.getDatabot("email", _vm.currentStore),
              autocomplete: "off",
              placeholder: "contact@societe.com"
            },
            on: {
              input: function($event) {
                return _vm.checkIfContactExists()
              }
            },
            model: {
              value: _vm.email,
              callback: function($$v) {
                _vm.email = $$v
              },
              expression: "email"
            }
          }),
          _vm._v(" "),
          _vm.getContactsList.length > 0
            ? _c("div", { staticClass: "alert alert-warning mt-3" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$l10n.__(
                        "Ce contact semble déjà exister sur cette société"
                      )
                    ) +
                    "\n        "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("form-fields-contacts-list", {
            attrs: {
              mode: "readOnly",
              readonly: "",
              "current-list": _vm.getContactsList,
              "display-nb-suggestion": false
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("contact-number", {
        attrs: { "current-store": _vm.currentStore, error: _vm.error }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }